function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Favourite({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 32 32",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: props.color || "#DEDAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.902 22.772l-.402-.328c-5.276-4.297-6.778-5.872-6.832-8.362-.046-2.117 1.492-3.923 3.604-4.07 1.904-.134 3.028.896 3.63 1.55.603-.654 1.729-1.684 3.632-1.55 2.112.148 3.65 1.954 3.603 4.07-.055 2.49-1.556 4.066-6.83 8.362l-.405.328z",
    fill: "#FFF"
  })));
}

const MemoFavourite = React.memo(Favourite);
export default MemoFavourite;